// material
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Grid, Card, Container, Typography, useMediaQuery } from '@mui/material';
//
import { varFadeInUp, MotionInView, varFadeInDown } from '../../animate';

// ----------------------------------------------------------------------

const CARDS = [
  {
    icon: '/static/icons/ic_document.svg',
    title: 'Créer fiche rapide'
  },
  {
    icon: '/static/icons/ic_anpoul.svg',
    title: 'Fonctions auto'
  },
  {
    icon: '/static/icons/ic_stats.svg',
    title: 'Rapport fluide'
  },
  {
    icon: '/static/icons/ic_business.svg',
    title: 'Limites boules'
  },
  {
    icon: '/static/icons/ic_chart.svg',
    title: 'Statistiques'
  },
  {
    icon: '/static/icons/ic_accelerate.svg',
    title: 'Plus tirage'
  },
  {
    icon: '/static/icons/ic_bank.svg',
    title: 'Option prépayé'
  }
];

const shadowIcon = (color) => `drop-shadow(2px 2px 2px ${alpha(color, 0.48)})`;

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(15),
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(15)
  }
}));

const CardStyle = styled(Card)(({ theme }) => {
  const shadowCard = (opacity) =>
    theme.palette.mode === 'light'
      ? alpha(theme.palette.grey[500], opacity)
      : alpha(theme.palette.common.black, opacity);

  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 320,
    minHeight: 220,
    margin: 'auto',
    boxShadow: `-40px 40px 80px 0 ${shadowCard(0.48)}`,
    [theme.breakpoints.up('md')]: {
      boxShadow: 'none',
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
    }
  };
});

const CardIconStyle = styled('img')(({ theme }) => ({
  width: 40,
  height: 40,
  marginBottom: theme.spacing(5),
  filter: shadowIcon(theme.palette.primary.main)
}));

// ----------------------------------------------------------------------

export default function LandingThavTechHelps() {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <RootStyle>
      <Container maxWidth="lg">
        <Box sx={{ mb: { xs: 10, md: 12 } }}>
          <MotionInView variants={varFadeInUp}>
            <Typography component="p" variant="overline" sx={{ mb: 2, color: 'text.secondary', textAlign: 'center' }}>
              ThavTech
            </Typography>
          </MotionInView>
          <MotionInView variants={varFadeInDown}>
            <Typography variant="h2" sx={{ textAlign: 'center' }}>
              En quoi ThavTech vous aide?
            </Typography>
          </MotionInView>
        </Box>

        <Grid container alignItems="center" justifyContent="center">
          <Box
            sx={{
              display: 'grid',
              gap: 3,
              gridTemplateColumns: {
                xs: 'repeat(2, 1fr)',
                sm: 'repeat(3, 1fr)',
                md: 'repeat(3, 1fr)',
                lg: 'repeat(5, 1fr)'
              }
            }}
          >
            {CARDS.map((card, index) => (
              <MotionInView key={index} variants={varFadeInUp}>
                <CardStyle>
                  <CardIconStyle src={card.icon} alt={card.title} />
                  <Typography variant="h6">{card.title}</Typography>
                </CardStyle>
              </MotionInView>
            ))}
          </Box>
        </Grid>
      </Container>
    </RootStyle>
  );
}
